
// src/reducers/subscribes-reducer.js

import { mergeArray, deleteArray } from '../helpers/store'

import { 
  SUBSCRIBE_DEVICE_TOKEN,
  SUBSCRIBE_DEVICE_TOKEN_REQUESTED,
  SUBSCRIBE_DEVICE_TOKEN_COMPLETED,
  SUBSCRIBE_DEVICE_TOKEN_FAILED,
} from '../actions/subscribe'

const initialState = {
  isFetching: false,
}

export default function subscribesReducer(state = initialState, action = {}) {
  switch(action.type) {
  case SUBSCRIBE_DEVICE_TOKEN_REQUESTED:
    return Object.assign({}, state, {
      isFetching: true,
    })

  case SUBSCRIBE_DEVICE_TOKEN_FAILED:
    return Object.assign({}, state, {
      isFetching: false,
    })

  case SUBSCRIBE_DEVICE_TOKEN_COMPLETED:
    return Object.assign({}, state, {
      isFetching: false,
    })

  default:
    return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/subscribe-reducer.js